import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  post: '',
  gender: '',
  phoneNumber: '',
  searchText: '',
  employeeType: '',
  department: '',
  staffCodeNumber: '',
  formerPublicRepresentative: false,
  publicRepresentativePost: '',
  pageNumber: 1,
  rowsPerPage: 50,
  tenureDateFrom: null,
  tenureDateTo: null
};

export const searchFilterReducerSlice = createSlice({
  name: "searchFilter",
  initialState,
  reducers: {
    setPost: (state, action) => {
      state.post = action.payload;
      state.pageNumber = 1;
    },
    setGender: (state, action) => {
      state.gender = action.payload;
      state.pageNumber = 1;
    },
    setEmployeeType: (state, action) => {
      state.employeeType = action.payload;
      state.pageNumber = 1;
    },
    setDepartment: (state, action) => {
      state.department = action.payload;
      state.pageNumber = 1;
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
      state.pageNumber = 1;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
      state.pageNumber = 1;
    },
    setStaffCodeNumber: (state, action) => {
      state.staffCodeNumber = action.payload;
      state.pageNumber = 1;
    },
    setFormerPublicReprsentative: (state, action) => {
      state.formerPublicRepresentative = action.payload;
      state.pageNumber = 1;
    },
    setPublicRepresentativePost: (state, action) => {
      state.publicRepresentativePost = action.payload;
      state.pageNumber = 1;
    },
    setTenureDateFrom: (state, action) => {
      state.tenureDateFrom = action.payload;
      state.pageNumber = 1;
    },
    setTenureDateTo: (state, action) => {
      state.tenureDateTo = action.payload;
      state.pageNumber = 1;
    },
    reset: () => initialState,
  }
});

export const {
  setGender,
  setPhoneNumber,
  setSearchText,
  setPost,
  setPageNumber,
  setRowsPerPage,
  setDepartment,
  setEmployeeType,
  setStaffCodeNumber,
  setFormerPublicReprsentative,
  setPublicRepresentativePost,
  setTenureDateFrom,
  setTenureDateTo,
  reset
} = searchFilterReducerSlice.actions;

export default searchFilterReducerSlice.reducer;
